import { colors } from "../utils/constants";

interface Props {
  text: string;
  className?: string;
}

const FormErrorMessage = ({ text, className = "" }: Props) => {
  return (
    <p style={{ color: colors.Red }} role="alert" className={className}>
      {text}
    </p>
  );
};

export default FormErrorMessage;
